import Navbar from 'react-bootstrap/Navbar';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router';
import logo from '../assets/keylexical-long.svg';
import { PageId } from '../types';
import './Header.scss';
import UserMenu from './UserMenu';

const Header = (props: { activeId?: PageId; loadingSeriesCount?: number }) => {
  const loadingCount = props.loadingSeriesCount || 0;
  return (<div className="d-lg-none">
    <Navbar className="mobile-logo-nav justify-content-center d-lg-none">
      <Navbar.Brand as={Link} to="/" className={props.activeId === PageId.INTRO ? 'logo active' : 'logo'}>
        <img src={logo} alt="" />
      </Navbar.Brand>
      {loadingCount > 0 && (
        <div className="header-loading-pill" role="status" aria-live="polite">
          <Spinner animation="border" size="sm" />
          <span>{loadingCount} loading</span>
        </div>
      )}
    </Navbar>
    <UserMenu />
  </div>);
};

export default Header;
